module.exports = __webpack_public_path__ + "static/media/hard-drive.12143e73.svg";